import dynamic from 'next/dynamic'

export const FormSection = dynamic(() => import('./form-section'))
